import { useMutation } from '@tanstack/react-query'
import { BillingApiClient } from '~/features/billing/services'
import { showErrorToast, showSuccessToast } from '@bpinternal/ui-kit-next'
import { getQueryKey } from '~/services'
import { queryClient } from '../../../providers/ReactQuery'

export function useSetPromoCode({ workspaceId }: { workspaceId: string }) {
  return useMutation({
    gcTime: 0,
    mutationFn: async ({ code }: { code: string }) => {
      return BillingApiClient.setPromoCode({ workspaceId, code })
    },
    onSuccess: () => {
      showSuccessToast('Promo code applied successfully')
      void queryClient.invalidateQueries({
        queryKey: getQueryKey('workspaces_/$workspaceId_/billing/promoCode', { workspaceId }),
      })
    },
    onError: (error) => {
      if (error.message === 'unexisting code') showErrorToast('Invalid promo code. Please check and try again')
      if (error.message === 'subscription already has a discount')
        showSuccessToast('This promo code is already applied and is active on your account')
    },
    meta: {
      suppressError: true,
    },
  })
}
